import React, { useState, useEffect } from "react";
import { Link, useLocation, useHistory } from "react-router-dom";
import { loadStripe } from "@stripe/stripe-js";

const stripePromise = loadStripe(
  "pk_live_51Q7o7fCG8S1F5Uj5YYDtnUHIDipkxlRrzGQl81qNSkkmRvlQnoyurSrJXBIUC8laspVAc5TtWUuoWEEJNCiOO8CE00IQRotPO4"
);

const CheckoutPage = () => {
  const location = useLocation();
  const history = useHistory();
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [email, setEmail] = useState("");
  const [name, setName] = useState(""); // New state for name

  useEffect(() => {
    if (location.state && location.state.plan) {
      console.log("Setting selected plan:", location.state.plan);
      setSelectedPlan(location.state.plan);
    } else {
      console.log("No plan in location state, redirecting to home");
      history.push("/");
    }
  }, [location.state, history]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("handleSubmit called");
    console.log("Current selectedPlan:", selectedPlan);

    if (!selectedPlan) {
      console.error("No plan selected");
      return;
    }

    const planId =
      selectedPlan.id || selectedPlan.name.toLowerCase().replace(" ", "_");

    console.log("Submitting form...", { name, email, planId });

    try {
      const stripe = await stripePromise;

      console.log("Creating checkout session...");
      const response = await fetch(
        `https://zap-zappp-backend.vercel.app/api/subscriptions/create-checkout-session`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            planId: planId,
            email: email,
            name: name, // Include name in the request
          }),
        }
      );

      console.log("Response status:", response.status);

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Network response was not ok: ${errorText}`);
      }

      const session = await response.json();
      console.log("Session:", session);

      if (!session.sessionId) {
        throw new Error("No sessionId received from server");
      }

      console.log("Redirecting to Stripe Checkout...");
      const result = await stripe.redirectToCheckout({
        sessionId: session.sessionId,
      });

      if (result.error) {
        console.error("Stripe redirect error:", result.error);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  if (!selectedPlan) {
    return <div>Loading...</div>;
  }

  return (
    <div className="flex justify-center items-center min-h-screen bg-gray-100">
      <div className="bg-white p-8 rounded-lg shadow-md w-full max-w-md">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-xl font-semibold">Checkout</h2>
          <Link to="/" className="text-gray-500 hover:text-gray-700">
            &times;
          </Link>
        </div>
        <p className="text-sm text-gray-600 mb-6">
          We automatically bill on the 1st of each month.
        </p>

        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <div className="bg-blue-100 p-2 rounded-lg mr-3">
                <svg
                  className="w-6 h-6 text-blue-500"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
              </div>
              <div>
                <p className="font-semibold">{selectedPlan.name} plan</p>
                <p className="text-sm text-gray-600">
                  You get {selectedPlan.hours} hours of VA support per month for
                  only ${selectedPlan.hourlyRate}/hr
                </p>
              </div>
            </div>
            <p className="font-semibold">
              ${selectedPlan.price}
              <span className="text-sm text-gray-600">/mth</span>
            </p>
          </div>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label
              className="block text-sm font-medium text-gray-700 mb-1"
              htmlFor="name"
            >
              Name
            </label>
            <input
              type="text"
              id="name"
              className="w-full px-3 py-2 border border-gray-300 rounded-md"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Enter your name"
              required
            />
          </div>

          <div className="mb-4">
            <label
              className="block text-sm font-medium text-gray-700 mb-1"
              htmlFor="email"
            >
              Email
            </label>
            <input
              type="email"
              id="email"
              className="w-full px-3 py-2 border border-gray-300 rounded-md"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              required
            />
          </div>

          <div className="flex justify-between items-center">
            <button type="button" className="text-gray-600 hover:text-gray-800">
              Help
            </button>
            <div>
              <button
                type="button"
                onClick={() => history.push("/")}
                className="mr-4 text-gray-600 hover:text-gray-800"
              >
                Cancel
              </button>
              <button
                type="submit"
                className="bg-purple-600 text-white px-4 py-2 rounded-md hover:bg-purple-700"
              >
                Proceed to Payment
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CheckoutPage;
